// Single source of truth for "block this user from peptide surfaces".
//
// Rules (per spec 2026-05-21-hide-peptides-from-sales-reps-design.md):
//   - Must be in "sales-rep" or "sales-rep-master" group
//   - Must NOT be in "supervisor" group (supervisor wins for combo users)
//   - Must NOT be an administrator (admin escape hatch preserved)
//
// Computed directly from `auth.user.groups` and `auth.user.role` rather than
// going through `hasGroup`, because `hasGroup` admin-bypasses by default and
// the explicit-flag form (`hasGroup(group, true)`) doesn't compose nicely
// across three callsites. A pure predicate on the auth shape is easier to
// test and reason about.
export function isNonAdminSalesRep(auth) {
  const groups = auth?.user?.groups;
  if (!Array.isArray(groups)) return false;
  if (auth?.user?.role === "administrator") return false;
  if (groups.includes("supervisor")) return false;
  return groups.includes("sales-rep") || groups.includes("sales-rep-master");
}
